import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetUserRoles } from "api/user";

export const userRolesGetThunk = createAsyncThunk(
    'user-roles-get',
    async () => {
        const res = await GetUserRoles();
        return res;
    },
);